import LazyLoadingBoardsList from "./lazy-loading-boards-list";

interface BoardsListProps {
    drawerIsOpen: boolean;
    height?: number; // Optional height prop for the lazy loading component
}

function BoardsList({ drawerIsOpen, height = 400 }: BoardsListProps) {
    return (
        <LazyLoadingBoardsList 
            drawerIsOpen={drawerIsOpen}
            height={height}
        />
    );
}

export default BoardsList; 